<template>
  <tr>
    <td width="105px" class="client-id">{{item.client_id}}</td>
    <td width="90px">{{item.login}}</td>
    <td>{{item.first_name}} {{item.last_name}}</td>
    <td width="200px">{{item.transfer_number}}</td>
    <td width="160px">
      <CustomDialog
          :visible="showFromAccDialog"
          @close="showFromAccDialog = false"
          title="Modal Bank Data"
          :confirmBtnText="null"
      >
        <template v-slot:body>
          <div class="row">
            <b>Balance:</b> <span>{{item.balance}}</span>
          </div>
        </template>
      </CustomDialog>
      <a class="tooltipped" @click="showFromAccDialog = true" data-position="top" :data-tooltip="balance_statistic">{{item.account_special_number}}
        ({{item.currency_abbreviation}})
      </a>
    </td>

    <td width="90px">
      <CustomDialog
        :visible="showIbanDialog"
        @close="showIbanDialog = false"
        title="Modal Bank Data"
        :confirmBtnText="null"
      >
        <template v-slot:body>
          <div class="row">
            <b>Bank Name: {{item.bank_name}}<br></b>
            <b>Bank Address: {{item.bank_address}}<br></b>
            <b>Swift Code:</b> {{item.swift_code}}<br>
            <b>Beneficiary Country:</b> {{item.beneficiary_country}}<br>
            <b>Beneficiary City:</b> {{item.beneficiary_city}}<br>
            <b>Beneficiary Address:</b> {{item.beneficiary_address}}<br>
            <div v-if="item.beneficiary_name">
              <b>Beneficiary Name:</b> {{item.beneficiary_name}}
            </div>
            <b>IBAN:</b> {{item.iban_code}}
          </div>
        </template>
      </CustomDialog>
      <a class="link" @click="showIbanDialog = true">{{item.iban_code}}</a>
    </td>

    <td width="300px">{{item.reference}}</td>
    <td>{{item.pay_charges}}</td>
    <td v-if="item.debit">{{item.debit}}</td>
    <td v-else>{{item.credit}}</td>
    <td>{{item.status_name}}</td>

    <td>
      <div v-if="item.status_name === 'pending'" class="buttons-container">
        <div
          class="accept-button"
          @click="$emit('openDialog', { status: 3, transfer: item.id })"
        >
          <CheckIcon width="12px" height="12px" color="#fff" />
        </div>
        <div class="close-button" @click="$emit('openDialog', { status: 2, transfer: item.id })">
          <CloseIcon width="12px" height="12px" color="#fff" />
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  import { required } from "vuelidate/lib/validators"
  import CheckIcon from "../icons/Checked"
  import CloseIcon from "../icons/Close"
  import CustomDialog from "../CustomDialog"

  export default {
    props: { item: Object },

    data: () => ({
      reference: '',
      showIbanDialog: false,
      showFromAccDialog: false,
    }),

    validations: {
      reference: { required },
    },

    computed: {
      balance_statistic: function () {
        // eslint-disable-next-line no-console
        console.log()
        return 'balance: ' + this.item.balance + ' / min: ' + this.item.min_balance
      }
    },

    components: {
      CheckIcon,
      CloseIcon,
      CustomDialog,
    },
  }
</script>

<style lang="scss" scoped>
  .client-id {
    text-align: center;
  }

  .main_div {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }
  .tooltipped {
    cursor: pointer;
  }

  .td-main-btn {
    margin-top: 10px;
  }

  .helper-text {
    color: red;
  }

  td {
    padding: 15px 25px 15px 0;
  }

  .buttons-container {
    display: flex;
    flex-direction: row;
  }

  .accept-button,
  .close-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  .accept-button {
    background: #26a69a;
    margin-right: 5px;
  }

  .close-button {
    background: #cc3f55;
  }

  .link {
    cursor: pointer;
  }
</style>
